import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  // Route,
} from "react-router-dom";
import "./index.css";
import App from './App';
import ErrorPage from "./error-page";
import Subcribe from "./comps/subcribe"
import reportWebVitals from './reportWebVitals';
import SubShips from "./comps/subcribe/SubShips";
import SubPersons from "./comps/subcribe/SubPersons";
import SubTargets from "./comps/subcribe/SubTargets";
import SubEvents from "./comps/subcribe/SubEvents";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/subscribe",
    element: <Subcribe />,
    children: [
      {
        path: "ships",
        element: <SubShips />
      },
      {
        path: "persons",
        element: <SubPersons />
      },
      {
        path: "targets",
        element: <SubTargets />
      },
      {
        path: "events",
        element: <SubEvents />
      },
    ]
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();